/**
 * Shared helpers for routing text into the right tool input.
 */

function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

export function getPrimaryInput(panelEl) {
  if (!panelEl) return null;

  const selector = panelEl.dataset.primaryInputSelector;
  const candidates = [];

  if (selector) candidates.push(panelEl.querySelector(selector));
  candidates.push(panelEl.querySelector('[data-primary-input="true"]'));
  candidates.push(...panelEl.querySelectorAll('.input-field'));

  return candidates.find((el) => el && !el.disabled && isVisible(el))
    || candidates.find(Boolean)
    || null;
}

export function applyTextToPrimaryInput(panelEl, text, { focus = false } = {}) {
  if (!panelEl || typeof text !== 'string') return false;

  const input = getPrimaryInput(panelEl);
  if (!input) return false;

  input.value = text;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  if (focus) input.focus();
  return true;
}
